import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SettingsModalComponent } from './modals/settings-modal/settings-modal.component';
import { ConfirmationModalService } from './services/confirmation-modal/confirmation-modal.service';
import { SharedModalComponent } from './modals/shared-modal/shared-modal.component';
import { FormValidationDirective } from './directives/form-validation.directive';
import { LinkRendererComponent } from './cell-renderers/link-renderer/link-renderer.component';
import { RouterModule } from '@angular/router';
import { ModalTemplateComponent } from './modals/modal-template/modal-template.component';
import { ToastrModule } from 'ngx-toastr';

//for Msal implementation
import { BrowserCacheLocation, InteractionType, IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';
import { MsalBroadcastService, MsalGuard, MsalGuardConfiguration, MsalInterceptor, MsalInterceptorConfiguration, MsalModule, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG } from '@azure/msal-angular';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ConfigService } from './services/config/config.service';

export function initializerFactory(env: ConfigService, configUrl: string): any {
  const promise = env.load().then((value) => {
      console.log('Configurations loaded.');
      console.log(window.location.origin);
  }).catch(function (err) {
    console.log(err);
  });
  return () => promise;
}

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: ConfigService.settings.clientId,
      authority: 'https://login.microsoftonline.com/'+ ConfigService.settings.tenantId,
      redirectUri: window.location.origin,
      navigateToLoginRequestUrl: false
    },
    cache: {
      cacheLocation : BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: false, // set to true for IE 11
    }
  });
}

export function MSALGuardConfigFactory(config: ConfigService): MsalGuardConfiguration {
  return { 
    interactionType: InteractionType.Redirect
  };
}

export function MSALInterceptorConfigFactory(config: ConfigService): MsalInterceptorConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap: new Map([
      ["https://graph.microsoft.com/v1.0/me", ['user.read']]
    ])
  };
}

@NgModule({
  declarations: [
    SettingsModalComponent,
    SharedModalComponent,
    FormValidationDirective,
    LinkRendererComponent,
    ModalTemplateComponent
  ],
  imports: [    
    CommonModule,
    RouterModule,  
    MsalModule, 
    ToastrModule.forRoot()
  ],
  exports: [
    SettingsModalComponent,
    ModalTemplateComponent,
    SharedModalComponent
  ],
  entryComponents:[
    SettingsModalComponent,
    SharedModalComponent,
    ModalTemplateComponent,
    LinkRendererComponent
  ]
})
export class SharedModule { 
  static forRoot() {
    return {
        ngModule: SharedModule,
        providers: [
          ConfigService,
          { provide: APP_INITIALIZER, 
            useFactory: initializerFactory, 
            deps: [ConfigService], 
            multi: true },
          {
              provide: MSAL_INSTANCE,
              useFactory: MSALInstanceFactory,
              deps: [ConfigService]
          },
          {
              provide: MSAL_GUARD_CONFIG,
              useFactory: MSALGuardConfigFactory,
              deps: [ConfigService]
          },
          {
              provide: MSAL_INTERCEPTOR_CONFIG,
              useFactory: MSALInterceptorConfigFactory,
              deps: [ConfigService]
          },
          ConfirmationModalService,
          MsalService,
          MsalGuard,
          MsalBroadcastService,
          {
              provide: HTTP_INTERCEPTORS,
              useClass: MsalInterceptor,
              multi: true
          }
        ]
    };
  }
}
